import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useEffect } from 'react';
import { AisFetch } from '../../features/ais.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';

interface PscAisEtaProps {
    imoNumber: string;
}

// Convert the date to standard
const DateConvert = (inputDateTime: Date): string => {
    return format(inputDateTime, 'dd-MMM-yyyy');
};

// Convert utc to  local time
const TimeConvert = (inputDateTime: Date): string => {
    return format(inputDateTime, 'hh:mm a');
};

const PscAisEta = ({ imoNumber }: PscAisEtaProps) => {
    const dispatch = useAppDispatch();
    const aisData = useAppSelector((state) => state.Ais.List[imoNumber]);

    useEffect(() => {
        if (!aisData) dispatch(AisFetch.GetByImoNumber(imoNumber));
    }, [imoNumber]);

    return (
        <>
            {!aisData || aisData.IsLoading ? (
                <CircularProgress size={18} />
            ) : aisData.AIS ? (
                // AIS Data Available
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <AccessTimeFilledIcon sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        {aisData.AIS?.Eta && DateConvert(aisData.AIS?.Eta)}
                        <Typography variant="caption" display="block">
                            {aisData.AIS?.Eta && TimeConvert(aisData.AIS?.Eta)}
                        </Typography>
                    </Stack>
                </Stack>
            ) : (
                // AIS Data NOT Available
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <ErrorOutlineOutlined sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        Not Found
                        <Typography variant="caption" display="block">
                            Note: Unable to Get AIS Data
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </>
    );
};

export default PscAisEta;
